import { render, staticRenderFns } from "./baseformedit.vue?vue&type=template&id=0fc37516"
import script from "./baseformedit.vue?vue&type=script&lang=js"
export * from "./baseformedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports